import React from "react"
import { View, StyleSheet, Text, ScrollView, Dimensions, Image, TouchableOpacity } from "react-native"
import { IconButton } from "react-native-paper"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { AntDesign } from "@expo/vector-icons"
import { MaterialCommunityIcons } from "@expo/vector-icons"

const { height, width } = Dimensions.get("screen")
export const PasswordChangeSuccess = ({ navigation }) => {
    const backToLogin = () => {
        navigation.navigate("Login")
    }

    return (
        <ContainerGlogal>
            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 50 }}>
                {/* <IconButton
                    rippleColor={"rgba(0,0,0,0.05)"}
                    onPress={() => backToLogin()}
                    icon="close"
                    color={baseColors.green.primary}
                    size={35}
                    style={{ alignSelf: "flex-end", marginRight: 20 }}
                /> */}

                <TouchableOpacity onPress={() => backToLogin()} style={{ alignSelf: "flex-end", padding: 20 }}>
                    <MaterialCommunityIcons name={"close"} size={35} color={baseColors.green.primary} />
                </TouchableOpacity>

                <View
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        flexDirection: "row",
                        marginTop: "45%"
                    }}
                >
                    <AntDesign name="Safety" size={100} color={baseColors.green.primary} />
                </View>
                <View style={[styles.container, { marginTop: 0 }]}>
                    <BreeSerifText textAlign={"center"} fontSize={20}>
                        Félicitations, votre mot de passe a été modifié.
                    </BreeSerifText>

                    <Button
                        text="Se connecter"
                        width="80%"
                        onPress={() => backToLogin()}
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
